import React from "react";
import { HintView } from "lib/components/index";

const Hint = () => (
  <HintView.Hint>
    <h3>{I18n.t("papp.products.EditProductView.StepDescription.hint.p1")}</h3>
    <p>{I18n.t("papp.products.EditProductView.StepDescription.hint.p2")}</p>

    <h3>{I18n.t("papp.products.EditProductView.StepDescription.hint.p3")}</h3>
    <p>{I18n.t("papp.products.EditProductView.StepDescription.hint.p4")}</p>

    <h3>{I18n.t("papp.products.EditProductView.StepDescription.hint.p5")}</h3>
    <p>{I18n.t("papp.products.EditProductView.StepDescription.hint.p6")}</p>

    <h3>{I18n.t("papp.products.EditProductView.StepDescription.hint.p7")}</h3>
    <p>{I18n.t("papp.products.EditProductView.StepDescription.hint.p8")}</p>

    <h3>{I18n.t("papp.products.EditProductView.StepDescription.hint.p9")}</h3>
    <p>{I18n.t("papp.products.EditProductView.StepDescription.hint.p10")}</p>

    <h3>{I18n.t("papp.products.EditProductView.StepDescription.hint.p11")}</h3>
    <p>{I18n.t("papp.products.EditProductView.StepDescription.hint.p12")}</p>

    <h3>{I18n.t("papp.products.EditProductView.StepDescription.hint.p13")}</h3>
    <p>{I18n.t("papp.products.EditProductView.StepDescription.hint.p14")}</p>
  </HintView.Hint>
);

export default Hint;



// WEBPACK FOOTER //
// ./src/modules/products/EditProductView/StepDescription/StepDescriptionHint.jsx